import { Component, OnInit } from '@angular/core';
import { EnvService } from '../../environments/env.service';
import { BrandingConfigService } from '../service/branding-config.service';


@Component({
  selector: 'nh-app-logo',
  template: `
    <a id="app-logo-parent" class="navbar-brand" href="{{issuerUrl}}" alt="logo"   >
    <img id="app-logo-img"
        src="{{logoUrl}}"
        alt="logo"
      />
    </a>
  `,
  styles: [".navbar-brand { background: none !important }"]
})
export class NhLogoComponent implements OnInit {

  public logoUrl: string = "";
  public issuerUrl: string = "";
  logo: any = null;
  brandingconfig:any = null;

  constructor(private envService: EnvService,  private service:BrandingConfigService) {
  if (envService.brandingLogoConfig)
  {
    this.logoUrl = envService.brandingLogoConfig;
    // this.logo = envService.application.logo;
    this.brandingconfig=this.service.getBrandingConfig(this.logoUrl)
    this.logoUrl = this.brandingconfig.logo;
  }
}


  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    let logoElement = document.getElementById("app-logo-img");
    let logoParent = document.getElementById("app-logo-parent");

    logoParent.style.top = this.brandingconfig.top;
    logoParent.style.left = this.brandingconfig.left;


    logoElement.style.width = this.brandingconfig.width;
    logoElement.style.height = this.brandingconfig.height;
  }

}
